import {IErrorResponse, IApiClientErrorDefinition} from "./Types";

/**
 * @class - ApiClientErrorCodes - error codes table for api client
 */
export class ApiClientErrorCodes {
    /**
     * @property GeneralValidationError - This is general validation error without providing specifics of error itself.
     */
    public static get NetworkError(): IErrorResponse {
        return {
            code: 100,
            errorId: '',
            message: 'network error'
        };
    }
}

/**
 * @class ApiClientErrorDefinitions - api client error definitions
 */
export class ApiClientErrorDefinitions {
    public static get SessionHasExpired(): IApiClientErrorDefinition {
        return {
            httpStatusCode: 500,
            code: 2012
        };
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/ApiClient/ApiClientErrorCodes.ts
 **/